let loaded = false;

export function loadRecaptchaV3(sitekey) {
  return new Promise((resolve, reject) => {
    if (!sitekey) return resolve(false);

    if (window.grecaptcha?.ready) {
      loaded = true;
      return window.grecaptcha.ready(() => resolve(true));
    }

    const existing = document.querySelector(`script[src="https://www.google.com/recaptcha/api.js?render=${sitekey}"]`);
    if (loaded || existing) {
      loaded = true;
      const waitForRecaptcha = () => {
        if (window.grecaptcha?.ready) {
          window.grecaptcha.ready(() => resolve(true));
        } else {
          setTimeout(waitForRecaptcha, 100);
        }
      };
      waitForRecaptcha();
      return;
    }

    const s = document.createElement("script");
    s.src = `https://www.google.com/recaptcha/api.js?render=${sitekey}`;
    s.async = true;
    s.defer = true;
    s.onload = () => {
      loaded = true;
      const waitForRecaptcha = () => {
        if (window.grecaptcha?.ready) {
          window.grecaptcha.ready(() => resolve(true));
        } else {
          setTimeout(waitForRecaptcha, 100);
        }
      };
      waitForRecaptcha();
    };
    s.onerror = reject;

    document.head.appendChild(s);
  });
}

export async function executeRecaptcha(sitekey, action) {
  if (!sitekey) return null;

  await loadRecaptchaV3(sitekey);

  if (!window.grecaptcha?.execute) return null;

  return await window.grecaptcha.execute(sitekey, { action });
}
